export default {
  name: 'End-users Activity',
  title: 'Report "End-Users Activity"',
  subtitle: 'Monthly and rolling 3-month activity metrics',
  generationNotice: 'Report generation may take some time',
  generatedAt: 'Generated at %{date}',
  columns: {
    period: 'Period',
    last3Months: 'Last 3 months of selected period (%{months})',
  },
  metrics: {
    'individual.activity': 'Individuals',
    'business.activity': 'Businesses',
    'account.activity': 'Accounts',
    'externalPaymentInstrument.activity': 'External Payment Instruments',
  },
  filters: {
    from: 'From',
    to: 'To',
  },
  export: {
    csv: 'CSV',
    excel: 'Excel',
  },
};
